import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Separator, HStack, VStack, Text } from '@chakra-ui/react';
import { RequestsGrid } from '@src/components/sco/Requests/RequestsGrid';
import { gql } from '@src/lib/gql';
import React from 'react';
export type RequestLPMyRequestsGridProps = {};
export const RequestLPMyRequestsGrid: React.FC<RequestLPMyRequestsGridProps> = props => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    query {
      currentUser {
        id
        userId
        groupRequests {
          id
          pagination {
            itemCount
          }
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  if (query.data?.currentUser?.groupRequests?.pagination?.itemCount > 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <HStack gap={6}><Separator flexGrow={1} /><Text color="colorPalette.fg" flexShrink={1} textStyle="label" whiteSpace="nowrap">My Goals</Text><Separator flexGrow={1} /></HStack>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = query.data?.currentUser?.userId;
    let t3;
    if ($[2] !== t2) {
      t3 = <VStack align="stretch" gap={6} marginTop={10} width="full">{t1}<RequestsGrid variables={{
          requestingUserId: t2
        }} /></VStack>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <></>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};